<script setup>
  /**
   * LoadingSpinner - Indicador de carregamento
   * OP-2026-0129: Frontend Admin SaaS
   */
  defineProps({
    size: {
      type: String,
      default: 'md', // sm, md, lg
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  })

  const sizeClasses = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border spinner-lg'
  }
</script>

<template>
  <div class="loading-spinner" :class="{ fullscreen }">
    <div class="text-center">
      <div class="spinner-border text-primary" :class="sizeClasses[size]" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <div v-if="message" class="mt-3 text-muted">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<style scoped>
  .spinner-lg {
    width: 3rem;
    height: 3rem;
  }
</style>
